module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-printer-0c1cd31b8076ff3b341c0542eed4281a.svg";